import Vue from 'vue'
import Vuex from 'vuex'

import defaultStates from '@/vuex/defaultStates'
import getters from '@/vuex/getters'
import mutations from '@/vuex/mutations'
import actions from '@/vuex/actions'
import modules from '@/vuex/modules'
import mixpanelContextPlugin from '@/vuex/plugins/mixpanel.context.plugin'
import mixpanelQueuePlugin from '@/vuex/plugins/mixpanel.queue.plugin'
import wordCloudModule from '@/vuex/modules/wordcloud.module'
import actionLog from '@/vuex/actionLog'
import spellcheckerPlugin from '@/vuex/plugins/spellchecker.plugin'

import kvSyncPlugins from '@/vuex/plugins/kvSync'
import subscribeCanvasBlockPluginLegacy from '@/vuex/plugins/canvasBlock.plugin'
import historyPlugin from '@/vuex/modules/history/history.plugin'
import rememberSettingPlugin from '@/vuex/plugins/rememberSetting.plugin'
import remoteControlPlugin from '@/vuex/plugins/remote-control.plugin'
import readinessCheckerStalePlugin from '@/vuex/plugins/readiness-checker-stale.plugin'
import categoriseModule from '@/vuex/modules/slides/categorise.module'
import planModule from '@/vuex/modules/plan.module'
import slideSettingModule from '@/vuex/modules/slide/slide.setting.module'
import routePrefetchPlugin from '@/vuex/plugins/route-prefetch.plugin'
import localStorageABTestPlugin from '@/vuex/plugins/local-storage-abtest.plugin'
import marketplaceRedeemPlugin from '@/vuex/plugins/marketplace-redeem.plugin'
import featureTogglesModule from './modules/featureToggles.module'
import skipSlideModule from '@/vuex/modules/skip-slide/skip-slide.module'
import audioModule from './modules/presentation/audio.module'
import embeddablePlugin from '@/vuex/modules/embeddable/embeddable.plugin'
import { isEmbedded } from '@/vuex/modules/embeddable/embeddable.utils'
import embedAppPlugin from '@/vuex/modules/embed-app/embed-app.plugin'
import slideAttributesCachePurgePlugin from '@/vuex/modules/slide-attributes/slide-attributes.cache-purge.plugin'
import htmlSlideCachePurgePlugin from '@/vuex/modules/slide-attributes/html-slide-cache-purge.plugin'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: defaultStates,
  getters,
  mutations,
  actions,
  modules,
  plugins: [
    mixpanelContextPlugin,
    mixpanelQueuePlugin,
    ...featureTogglesModule.plugins,
    wordCloudModule.plugins.subscribeSlideVersionPlugin,
    ...kvSyncPlugins,
    subscribeCanvasBlockPluginLegacy,
    spellcheckerPlugin,
    historyPlugin,
    rememberSettingPlugin,
    remoteControlPlugin,
    readinessCheckerStalePlugin,
    ...categoriseModule.plugins,
    planModule.plugin,
    slideSettingModule.plugin,
    routePrefetchPlugin,
    localStorageABTestPlugin,
    marketplaceRedeemPlugin,
    skipSlideModule.plugin,
    slideAttributesCachePurgePlugin,
    htmlSlideCachePurgePlugin,
    ...audioModule.plugins,
    ...(isEmbedded() ? [embeddablePlugin] : []),
    embedAppPlugin,
  ],
})

// init log action error from vuex
actionLog.initActionLog(store)

export default store
